"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.findClosestPointOnLineSegment = findClosestPointOnLineSegment;
exports.updateRectanglePosition = updateRectanglePosition;

var _immutableFeatureCollection = _interopRequireDefault(require("./immutable-feature-collection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var GEOJSON_TYPE = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon'
};
var SHAPE = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  RECTANGLE: 'Rectangle',
  CIRCLE: 'Circle'
};
var GUIDE_TYPE = {
  TENTATIVE: 'tentative',
  EDIT_HANDLE: 'editHandle',
  CURSOR_EDIT_HANDLE: 'cursorEditHandle'
};
var ELEMENT_TYPE = {
  FEATURE: 'feature',
  FILL: 'fill',
  SEGMENT: 'segment',
  EDIT_HANDLE: 'editHandle'
};
var EDIT_TYPE = {
  ADD_FEATURE: 'addFeature',
  ADD_POSITION: 'addPosition',
  REMOVE_POSITION: 'removePosition',
  MOVE_POSITION: 'movePosition',
  FINISH_MOVE_POSITION: 'finishMovePosition'
};

function isNumeric(val) {
  return !Array.isArray(val) && !Number.isNaN(parseFloat(val)) && Number.isFinite(val);
}

function getFeatureCoordinates(feature) {
  var coordinates = feature && feature.geometry && feature.geometry.coordinates;

  if (!coordinates) {
    return null;
  }

  var isPolygonal = feature.geometry.type === 'Polygon';
  var isSinglePoint = feature.geometry.type === 'Point';

  if (isPolygonal) {
    return coordinates[0];
  } else if (isSinglePoint) {
    return [coordinates];
  }

  return coordinates;
}

function inBounds(p1, p2, p) {
  var bounds = [Math.min(p1[0], p2[0]), Math.max(p1[0], p2[0]), Math.min(p1[1], p2[1]), Math.max(p1[1], p2[1])];
  return p[0] >= bounds[0] && p[0] <= bounds[1] && p[1] >= bounds[2] && p[1] <= bounds[3];
}

function findClosestPointOnLineSegment(p1, p2, p) {
  // line
  var k = (p2[1] - p1[1]) / (p2[0] - p1[0]);
  var b = p1[1] - k * p1[0]; // vertical line

  if (!Number.isFinite(k)) {
    var q = [p1[0], p[1]];
    return inBounds(p1, p2, q) ? q : null;
  } // p is on line [p1, p2]


  if (p[0] * k + b - p[1] === 0) {
    return inBounds(p1, p2, p) ? p : null;
  }

  var qx = (k * p[1] + p[0] - k * b) / (k * k + 1);
  var qy = k * qx + b;
  return inBounds(p1, p2, [qx, qy]) ? [qx, qy] : null;
}

function updateRectanglePosition(feature, editHandleIndex, mapCoords) {
  var coordinates = getFeatureCoordinates(feature);

  if (!coordinates) {
    return null;
  }

  var points = coordinates.slice(0, 4);
  points[editHandleIndex % 4] = mapCoords;
  /*
   *   p0.x, p0.y (p0) ------ p2.x, p0.y (p1)
   *       |                      |
   *       |                      |
   *   p0.x, p2.y (p3) ----- p2.x, p2.y (p2)
   */

  var p0 = points[(editHandleIndex + 2) % 4];
  var p2 = points[editHandleIndex % 4];
  points[(editHandleIndex + 1) % 4] = [p2[0], p0[1]];
  points[(editHandleIndex + 3) % 4] = [p0[0], p2[1]];
  return feature.geometry.type === GEOJSON_TYPE.POLYGON ? [[].concat(_toConsumableArray(points), [points[0]])] : points;
}

var EditingMode = /*#__PURE__*/function () {
  function EditingMode() {
    _classCallCheck(this, EditingMode);

    this._tentativeFeature = null;
    this._editHandles = null;
  }

  _createClass(EditingMode, [{
    key: "handlePan",
    value: function handlePan() {}
  }, {
    key: "handleDblClick",
    value: function handleDblClick() {}
  }, {
    key: "handleStartDragging",
    value: function handleStartDragging() {}
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp() {}
  }, {
    key: "getTooltips",
    value: function getTooltips() {
      return [];
    }
  }, {
    key: "handleDragging",
    value: function handleDragging() {}
  }, {
    key: "getTentativeFeature",
    value: function getTentativeFeature() {
      return this._tentativeFeature;
    }
  }, {
    key: "getEditHandles",
    value: function getEditHandles() {
      return this._editHandles;
    }
  }, {
    key: "setTentativeFeature",
    value: function setTentativeFeature(feature) {
      this._tentativeFeature = feature;
    }
  }, {
    key: "getEditHandlesFromFeature",
    value: function getEditHandlesFromFeature(feature, featureIndex) {
      var coordinates = getFeatureCoordinates(feature);

      if (!coordinates) {
        return null;
      }

      return coordinates.map(function (coord, i) {
        return {
          type: 'Feature',
          properties: {
            // TODO deprecate renderType
            renderType: feature.properties.renderType,
            guideType: GUIDE_TYPE.EDIT_HANDLE,
            editHandleType: 'existing',
            featureIndex: featureIndex,
            positionIndexes: [i]
          },
          geometry: {
            type: GEOJSON_TYPE.POINT,
            coordinates: coord
          }
        };
      });
    }
  }, {
    key: "getSelectedFeature",
    value: function getSelectedFeature(props, featureIndex) {
      var data = props.data,
          selectedIndexes = props.selectedIndexes;
      var features = data && data.features;
      var selectedIndex = isNumeric(featureIndex) ? Number(featureIndex) : selectedIndexes && selectedIndexes[0];
      return features && features[selectedIndex];
    }
  }, {
    key: "handleClick",
    value: function handleClick(event, props) {
      var picked = event.picks && event.picks[0];
      var selectedFeatureIndex = props.selectedIndexes && props.selectedIndexes[0];

      if (!picked || !picked.object || picked.featureIndex !== selectedFeatureIndex) {
        return;
      }

      var objectType = picked.type,
          featureIndex = picked.featureIndex,
          index = picked.index;
      var feature = this.getSelectedFeature(props, featureIndex);

      if (feature && (feature.geometry.type === GEOJSON_TYPE.POLYGON || feature.geometry.type === GEOJSON_TYPE.LINE_STRING) && objectType === ELEMENT_TYPE.SEGMENT) {
        var coordinates = getFeatureCoordinates(feature);

        if (!coordinates) {
          return;
        }

        var insertIndex = (index + 1) % coordinates.length;
        var positionIndexes = feature.geometry.type === SHAPE.POLYGON ? [0, insertIndex] : [insertIndex];

        var insertMapCoords = this._getPointOnSegment(feature, picked, event.mapCoords);

        var updatedData = new _immutableFeatureCollection["default"](props.data).addPosition(featureIndex, positionIndexes, insertMapCoords).getObject();
        props.onEdit({
          editType: EDIT_TYPE.ADD_POSITION,
          updatedData: updatedData,
          editContext: [{
            featureIndex: featureIndex,
            editHandleIndex: insertIndex,
            screenCoords: props.viewport && props.viewport.project(insertMapCoords),
            mapCoords: insertMapCoords
          }]
        });
      }
    }
  }, {
    key: "handleStopDragging",
    value: function handleStopDragging(event, props) {
      // replace point
      var picked = event.picks && event.picks[0];

      if (!picked || !picked.Object || !isNumeric(picked.featureIndex)) {
        return;
      }

      var pickedObject = picked.object;

      switch (pickedObject.type) {
        case ELEMENT_TYPE.FEATURE:
        case ELEMENT_TYPE.FILL:
        case ELEMENT_TYPE.EDIT_HANDLE:
          this._handleDragging(event, props);

          break;

        default:
      }
    }
  }, {
    key: "_handleDragging",
    value: function _handleDragging(event, props) {
      var onEdit = props.onEdit;
      var selectedFeature = this.getSelectedFeature(props); // nothing clicked

      var isDragging = event.isDragging,
          pointerDownPicks = event.pointerDownPicks,
          screenCoords = event.screenCoords;
      var lastPointerMoveEvent = props.lastPointerMoveEvent;
      var clicked = pointerDownPicks && pointerDownPicks[0];

      if (!clicked || !clicked.object || !isNumeric(clicked.featureIndex)) {
        return;
      }

      var objectType = clicked.type,
          editHandleIndex = clicked.index; // not dragging

      var updatedData = null;
      var editType = isDragging ? EDIT_TYPE.MOVE_POSITION : EDIT_TYPE.FINISH_MOVE_POSITION;

      switch (objectType) {
        case ELEMENT_TYPE.FEATURE:
        case ELEMENT_TYPE.FILL:
        case ELEMENT_TYPE.SEGMENT:
          {
            if (!props.featuresDraggable) {
              break;
            } // dragging feature


            var dx = screenCoords[0] - lastPointerMoveEvent.screenCoords[0];
            var dy = screenCoords[1] - lastPointerMoveEvent.screenCoords[1];
            updatedData = this._updateFeature(props, 'feature', {
              dx: dx,
              dy: dy
            });
            onEdit({
              editType: editType,
              updatedData: updatedData,
              editContext: null
            });
            break;
          }

        case ELEMENT_TYPE.EDIT_HANDLE:
          {
            // dragging editHandle
            // dragging rectangle or other shapes
            var updateType = selectedFeature.properties.shape === SHAPE.RECTANGLE ? 'rectangle' : 'editHandle';
            updatedData = this._updateFeature(props, updateType, {
              editHandleIndex: editHandleIndex,
              mapCoords: event.mapCoords
            });
            onEdit({
              editType: editType,
              updatedData: updatedData,
              editContext: null
            });
            break;
          }

        default:
      }
    }
  }, {
    key: "handlePointerMove",
    value: function handlePointerMove(event, props) {
      // no selected feature
      var selectedFeature = this.getSelectedFeature(props);

      if (!selectedFeature) {
        return;
      }

      if (!event.isDragging) {
        return;
      }

      this._handleDragging(event, props);
    } // TODO - refactor

  }, {
    key: "_updateFeature",
    value: function _updateFeature(props, type) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var data = props.data,
          selectedIndexes = props.selectedIndexes,
          viewport = props.viewport;
      var featureIndex = selectedIndexes && selectedIndexes[0];
      var feature = this.getSelectedFeature(props, featureIndex);
      var geometry = null;
      var coordinates = getFeatureCoordinates(feature);

      if (!coordinates) {
        return null;
      }

      var newCoordinates = _toConsumableArray(coordinates);

      switch (type) {
        case 'editHandle':
          {
            var positionIndexes = feature.geometry.type === GEOJSON_TYPE.POLYGON ? [0, options.editHandleIndex] : [options.editHandleIndex];
            return new _immutableFeatureCollection["default"](data).replacePosition(featureIndex, positionIndexes, options.mapCoords).getObject();
          }

        case 'feature':
          {
            var dx = options.dx,
                dy = options.dy;
            newCoordinates = newCoordinates.map(function (mapCoords) {
              var pixels = viewport && viewport.project(mapCoords);

              if (pixels) {
                pixels[0] += dx;
                pixels[1] += dy;
                return viewport && viewport.unproject(pixels);
              }

              return null;
            }).filter(Boolean);
            geometry = {
              type: feature.geometry.type,
              coordinates: feature.geometry.type === GEOJSON_TYPE.POLYGON ? [newCoordinates] : feature.geometry.type === GEOJSON_TYPE.POINT ? newCoordinates[0] : newCoordinates
            };
            return new _immutableFeatureCollection["default"](data).replaceGeometry(featureIndex, geometry).getObject();
          }

        case 'rectangle':
          {
            // moved editHandleIndex and destination mapCoords
            newCoordinates = updateRectanglePosition(feature, options.editHandleIndex, options.mapCoords);
            geometry = {
              type: GEOJSON_TYPE.POLYGON,
              coordinates: newCoordinates
            };
            return new _immutableFeatureCollection["default"](data).replaceGeometry(featureIndex, geometry).getObject();
          }

        default:
          {
            return data && new _immutableFeatureCollection["default"](data).getObject();
          }
      }
    }
  }, {
    key: "_getPointOnSegment",
    value: function _getPointOnSegment(feature, picked, pickedMapCoords) {
      var coordinates = getFeatureCoordinates(feature);

      if (!coordinates) {
        return null;
      }

      var srcVertexIndex = picked.index;
      var targetVertexIndex = picked.index + 1;
      return findClosestPointOnLineSegment(coordinates[srcVertexIndex], coordinates[targetVertexIndex], pickedMapCoords);
    }
  }, {
    key: "_getCursorEditHandle",
    value: function _getCursorEditHandle(event, feature) {
      var isDragging = event.isDragging,
          picks = event.picks; // if not pick segment

      var picked = picks && picks[0];

      if (!picked || !isNumeric(picked.featureIndex) || picked.type !== ELEMENT_TYPE.SEGMENT) {
        return null;
      } // if dragging or feature is neither polygon nor line string


      if (isDragging || feature.geometry.type !== GEOJSON_TYPE.POLYGON && feature.geometry.type !== GEOJSON_TYPE.LINE_STRING) {
        return null;
      }

      var insertMapCoords = this._getPointOnSegment(feature, picked, event.mapCoords);

      if (!insertMapCoords) {
        return null;
      }

      return {
        type: 'Feature',
        properties: {
          guideType: GUIDE_TYPE.CURSOR_EDIT_HANDLE,
          shape: feature.properties.shape,
          positionIndexes: [-1],
          editHandleType: 'intermediate'
        },
        geometry: {
          type: GEOJSON_TYPE.POINT,
          coordinates: insertMapCoords
        }
      };
    }
  }, {
    key: "getGuides",
    value: function getGuides(props) {
      var selectedFeature = this.getSelectedFeature(props);
      var selectedFeatureIndex = props.selectedIndexes && props.selectedIndexes[0];

      if (!selectedFeature || selectedFeature.geometry.type === GEOJSON_TYPE.POINT) {
        return null;
      }

      var event = props.lastPointerMoveEvent; // feature editHandles

      var editHandles = this.getEditHandlesFromFeature(selectedFeature, selectedFeatureIndex) || []; // cursor editHandle

      var cursorEditHandle = this._getCursorEditHandle(event, selectedFeature);

      if (cursorEditHandle) {
        editHandles.push(cursorEditHandle);
      }

      return {
        type: 'FeatureCollection',
        features: editHandles.length ? editHandles : null
      };
    }
  }]);

  return EditingMode;
}();

exports["default"] = EditingMode;